<template>
  <div>
    <chrome-picker
      v-if="label"
      v-model="color"
      style="box-shadow:none;border:1px solid #ddd;"
      class="color-pickr"
    />
    <slider-picker v-else v-model="color" />
  </div>
</template>

<script>
import { Chrome, Slider } from "vue-color";
export default {
  name: "color",
  data() {
    return {
      model: null,
      color: {
        hex: this.model
      }
    };
  },
  props: ["input", "form", "label", "value"],
  created() {
    if (this.value) {
      this.color.hex = this.value;
    }
  },
  components: {
    "chrome-picker": Chrome,
    "slider-picker": Slider
  },
  watch: {
    form() {
      if (this.form) {
        this.model = null;
      }
    },
    color() {
      this.$parent.$emit("changed", {
        name: this.input.name,
        value: this.color.hex
      });
    }
  }
};
</script>

<style>
.uk-offcanvas-bar .color-pickr {
  width: 100%;
}
</style>
